import styled, { css } from 'styled-components'
import { Media, hideScrollbar } from '@raysync/common/theme'

export const TabWrap = styled.div`
  width: 100%;
`

export const TabHeader = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e7ebef;
  ${Media.phone`
    display:block;
    overflow-x: auto;
    width: 100%;
    white-space: nowrap;
    font-size: initial;
    padding: 0 0.45rem;
    ${hideScrollbar};
  `}
`

export const TabContent = styled.div`
  ${({ theme: { color } }) => css`
    margin-top: 40px;
    width: 100%;
    height: 300px;
    background-color: ${color.panel};
  `}
`

export const TabTitle = styled.span`
  ${({ theme: { color } }) => css`
    display: inline-block;
    margin: 0 32px;
    padding: 18px 10px;
    a {
      font-size: 20px;
      line-height: 20px;
      :hover {
        color: ${color.primary};
      }
    }
    ${p =>
      p.active &&
      css`
        border-bottom: 3px solid ${color.secondary};
      `}
    ${Media.phone`
      margin: initial;
      padding: .3rem .2rem .28rem .2rem;
      font-size:.3rem;
      :first-child{
        padding-left: 0;
      }
      :last-child{
        padding-right: 0;
      }
      a {
        font-size: .3rem;
      }
    `}
  `}
`
